import globalDomains from '@/utils/global-domains';
import ApiCore from '@/api/index';

const ResApi = ApiCore(globalDomains.RES_AFREECATV);
export default ResApi;
